import React from 'react';
import { Area, AreaChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import type { IncomeStep } from '../../utils/partnerPortal';
import { formatCentsAud } from '../../utils/partnerReferrals';

const LINE = '#3b82f6';

const dateLabel = (ms: number) =>
  new Date(ms).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' });

/** Cumulative settled fees, one step per settlement. Single series: no legend, the card title names it. */
export const IncomeStepChart: React.FC<{ steps: IncomeStep[] }> = ({ steps }) => {
  if (steps.length === 0) return null;
  // Start the line at zero just before the first settlement so the first step is visible.
  const data = [{ at: steps[0].at - 1, cumulativeIncGstCents: 0 }, ...steps];
  return (
    <div className="h-24" role="img" aria-label="Cumulative referral income over time">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 4, right: 4, bottom: 0, left: 4 }}>
          <defs>
            <linearGradient id="partnerIncomeFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={LINE} stopOpacity={0.25} />
              <stop offset="100%" stopColor={LINE} stopOpacity={0} />
            </linearGradient>
          </defs>
          <XAxis dataKey="at" type="number" domain={['dataMin', 'dataMax']} hide />
          <YAxis hide domain={[0, 'dataMax']} />
          <Tooltip
            cursor={{ stroke: '#4b5563' }}
            contentStyle={{ background: '#111827', border: '1px solid #374151', borderRadius: '0.5rem', fontSize: '0.75rem' }}
            labelStyle={{ color: '#9ca3af' }}
            itemStyle={{ color: '#f3f4f6' }}
            labelFormatter={(v) => dateLabel(Number(v))}
            formatter={(v) => [formatCentsAud(Number(v)), 'Earned to date']}
          />
          <Area
            type="stepAfter"
            dataKey="cumulativeIncGstCents"
            stroke={LINE}
            strokeWidth={2}
            fill="url(#partnerIncomeFill)"
            isAnimationActive={false}
            dot={false}
            activeDot={{ r: 4 }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default IncomeStepChart;
